import Vue from 'vue'
import Router from 'vue-router'

import Landing from "@/views/Landing.vue";
import Home from '@/views/Home.vue'

import RequestAccess from "@/views/RequestAccess.vue";
import Timeout from "@/views/Timeout.vue";
import Thanks from "@/views/Thanks.vue";
import Unauthorized from "@/views/Unauthorized.vue";

import Approval from '@/views/Approval.vue'

import RespSafeRegistration from "@/views/RespSafeReg.vue";
import RespSafeSubmissionConfirmation from "@/views/RespSafeRegConfirmation.vue";
import RespSafeContact from "@/views/RespSafeRegContact.vue";
import {store} from "@/store/store";
import FacilityManagement from "@/views/FacilityManagement.vue";
import RespSafeReport from "@/views/RespSafeReport.vue";
import RespSafeReportModule from "@/views/RespSafeReportModule.vue";
import RespSafeReportConfirmation from "@/views/RespSafeReportConfirmation.vue";
import UserManagementEdit from "@/views/UserManagementEdit.vue";
import UserManagementAdd from "@/views/UserManagementAdd.vue";
import UserManagementAccVerify from "@/views/UserManagementAccVerify.vue";
import UserManagementSearch from "@/views/UserManagementSearch.vue";
import CheckStatus from "@/views/CheckStatus.vue";
import CollectConsent from "@/views/CollectConsent.vue";
import RespSafeHistory from "@/views/RespSafeHistory.vue";

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'landing',
      meta: {
        requiresAuth: false
      },
      component: Landing
    },
    {
      path: '/consent',
      name: 'consent',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: CollectConsent
    },
    {
      path: '/checkStatus',
      name: 'checkStatus',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: CheckStatus
    },
    {
      path: '/userManagementSearch',
      name: 'userManagementSearch',
      meta: {
          requiresAuth: true,
          authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin' ]
      },
      component: UserManagementSearch
    },
    {
      path: '/userManagementAccVerify',
      name: 'userManagementAccVerify',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin' ]
      },
      component: UserManagementAccVerify
    },
    {
      path: '/userManagementAdd',
      name: 'userManagementAdd',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin' ]
      },
      component: UserManagementAdd
    },
    {
      path: '/userManagementEdit',
      name: 'userManagementEdit',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin' ]
      },
      component: UserManagementEdit
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: Home
    },
    {
      path: '/respSafeReg',
      name: 'respSafeReg',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: RespSafeRegistration
    },
    {
      path: '/respSafeContact',
      name: 'respSafeContact',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: RespSafeContact
    },
    {
      path: '/respSafeSubmission',
      name: 'respSafeSubmission',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: RespSafeSubmissionConfirmation
    },
    {
      path: '/respSafeReport',
      name: 'respSafeReport',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: RespSafeReport
    },
    {
      path: '/respSafeReportModule',
      name: 'respSafeReportModule',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: RespSafeReportModule
    },
    {
      path: '/respSafeReportConfirmation',
      name: 'respSafeReportConfirmation',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin', 'org-user' ]
      },
      component: RespSafeReportConfirmation
    },
    {
      path: '/respSafeHistory',
      name: 'respSafeHistory',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin' ]
      },
      component: RespSafeHistory
    },
    {
      path: '/facilityManagement',
      name: 'facilityManagement',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin', 'org-admin' ]
      },
      component: FacilityManagement
    },
    {
      path: '/admin/approval',
      name: 'approval',
      meta: {
        requiresAuth: true,
        authRoles: [ 'mdh-admin', 'mnit-admin' ]
      },
      component: Approval
    },
    {
      path: '/requestAccess',
      name: 'requestAccess',
      meta: {
        requiresAuth: false
      },
      component: RequestAccess
    },
    {
      path: '/timeout',
      name: 'timeout',
      meta: {
        requiresAuth: false
      },
      component: Timeout
    },
    {
      path: "/thanks",
      name: 'thanks',
      meta: {
        requiresAuth: false,
      },
      component: Thanks
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false
      },
      component: Unauthorized
    },
    {
      path: '*', 
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Redirect to home after registration
  if (to.name === 'landing' && router.app.$keycloak && router.app.$keycloak.authenticated) {
    router.push('home')
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak && router.app.$keycloak.authenticated) {
      if (to.meta.authRoles) {
        let hasRole = false
        for (let i = 0; i < to.meta.authRoles.length; i++) {
          if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i])) {
            hasRole = true;
          }
        }
        if (hasRole) {
          next()
        } else {
          router.push('unauthorized') 
        }
      } else {
        next();
      }
    } else {
      const loginUrl = Vue.prototype.$keycloak.loginUrl;
      window.location.replace(loginUrl)
    }
  } else {
    next()
  }
})

let announcer = document.getElementById('announcer');
router.afterEach(function(to) {
  if (!to.name) { return; }
  announcer.innerHTML = `${to.name} page has loaded`;
  if (store.state.selectedFacility) {
    if (to.name === "respSafeContact" || to.name === "respSafeSubmission" || to.name === "userManagementAccVerify" || to.name === "userManagementAdd"
        || to.name === "respSafeReportModule" || to.name === "respSafeReportConfirmation" || to.name === "userManagementEdit") {
      console.log()
    } else {
      store.state.selectedFacility = undefined
    }

  }
});

export default router
